//let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return {
      event: null,
    };
  },
  Radio_setup() {
    return {
      company_change(event) {
        this.setState({event});
      }
    };
  },
  __close: esUtils.wrapPreventDefault(function () {
    this.setState({event: null});
  }),
  render() {
    let {event} = this.state;
    if (!event) {
      return dd.span();
    }
    return Modal({
        title: "Company change warning",
        buttons: [
          {
            name: "OK",
            onClick: this.__close,
            className: "btn btn-primary"
          }
        ]
      },
      "You have changed the event COMPANY, which cleared these fields: specific content area, PD Rep, Sales Rep."
    ) ;
  }
});



// WEBPACK FOOTER //
// ./src/components/modals/EventCompanyChange.js